module.exports = __webpack_public_path__ + "img/2826d6eea015c2fed4d727240aa67b97.18c7937d.jpg";